import { ridgewoodConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function RidgewoodPage() {
  return <CityPageTemplate config={ridgewoodConfig} />;
}